module.exports = global["$"] = require("-!C:\\git\\xfinity-myplan\\Comcast.MyPlan.Web.Ui\\node_modules\\expose-loader\\index.js?jQuery!C:\\git\\xfinity-myplan\\Comcast.MyPlan.Web.Ui\\node_modules\\jquery\\dist\\jquery.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/dist/jquery.js
 ** module id = 131
 ** module chunks = 0
 **/